<main>
  <app-externalmenu></app-externalmenu>
  <div class="wrapper  " [ngClass]="{'expanded': isSidebarCollapsed}">
    <div class="d-flex align-items-start mt-2">

      <div class="RolesDropdowns">
        <div class="Groupdropdown ">
          <div class="dropdown-header " (click)="toggleRoleDropdown($event)">
            {{ getSelectedRoleName() }}
            <span class="arrow" [ngClass]="{ 'open': roleDropdownOpen }">&#9662;</span>
          </div>

          <div class="dropdown-list" *ngIf="roleDropdownOpen">
            <div class="dropdown-item" *ngFor="let role of roles" (click)="getRoleWidgets(role)">
              {{ role.Role_Name || 'Unnamed role' }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="Roles-container" style="width: -webkit-fill-available;">
        <div class="permissions" *ngIf="!isaddwidget">
          <form (ngSubmit)="saveRoleWidgets()" #roleForm="ngForm">
            <p class="Rtitle-bold text-center">Categories & Widgets</p>

            <div *ngFor="let cat of categoriesWithWidgets" class="category-box">

              <!-- Parent (category) -->
              <div class="form-check">
                <input type="checkbox" [id]="'cat-' + cat.TWL_ID" [(ngModel)]="cat.selected"
                  [indeterminate]="cat.indeterminate" (change)="toggleCategory(cat)"
                  [name]="'categorySelection' + cat.TWL_ID" [disabled]="!currentEditingRole"
                  class="form-check-input ms-2">
                <label class="form-check-label ms-2 mt-2" [for]="'cat-' + cat.TWL_ID">
                  {{ cat.TWL_NAME }}
                </label>
              </div>

              <!-- Children (widgets) -->
              <div class="widgets-wrap">
                <div class="form-check" *ngFor="let widget of cat.widgets">
                  <input type="checkbox" [id]="'widget-' + widget.Widget_id" [(ngModel)]="widget.selected"
                    (change)="updateCategoryState(cat)" [name]="'widgetSelection' + widget.Widget_id"
                    [disabled]="!currentEditingRole" class="form-check-input ms-2">
                  <label class="form-check-label ms-2 mt-2" [for]="'widget-' + widget.Widget_id">
                    {{ widget.Widget_name }}
                  </label>
                </div>
              </div>
            </div>

            <button type="submit" class="btn btn-primary mt-2 ms-5 mb-2" [disabled]="loading">
              Save
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</main>






<div *ngIf="loading" class="loading-overlay">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>